// extracted by mini-css-extract-plugin
export default {"header-box":"BridgeRecord_header-box__pKtF9","value-box":"BridgeRecord_value-box__iitfB","word-break":"BridgeRecord_word-break__aLPQD"};